import ETC_AXIOS from './etc.axios'
import APP from '../config/app'
import store from '@/store'
// 获取落地页模板
export const apiGetTemplate = (data = {}) => {
  return ETC_AXIOS.post(
    APP.HTTP_GW_URL + '/transfer/pass/apply/frontend/apply-page/get-by-page-sn-with-template', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// 获取绑定卡
export const apiGetBindCardList = (data = {}) => {
  const channel = store.state.channel
  return ETC_AXIOS.post(
    APP.HTTP_GW_URL + '/api/apply/frontend/externalBind/getList',
    {
      channel,
      ...data
    },
    {isJson: true, headers: { 'content-type': 'application/json' }}
  )
}

// 获取绑定卡信息
export const apiGetBindCardDetail = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/apply/frontend/externalBind/getDetail', data)
}

// 绑定时获取验证码
export const apiSendBindCardVerifyCode = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/apply/frontend/externalBind/sendVerifyCode', data)
}

// 绑定操作接口
export const apiBindCard = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/apply/frontend/externalBind/bind', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// [H5|Website] - 车牌状态查询
export const apiCheckPlateNo = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/etc-saleafter-main/saleafter/website/check-plate-no/check', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// [H5|Website] - 车牌状态查询列表
export const apiCheckPlateNoList = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/etc-saleafter-main/saleafter/website/check-plate-no/list', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// [H5|Website] - 车牌状态查询详情
export const apiCheckPlateNoDetail = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/etc-saleafter-main/saleafter/website/check-plate-no/detail', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// [H5|Website] - 车牌状态查询引导
export const apiCheckPlateNoGuide = (data = {}) => {
  return ETC_AXIOS.post(
     APP.HTTP_GW_URL + '/api/etc-saleafter-main/saleafter/website/check-plate-no/guide', data, {isJson: true, headers: { 'content-type': 'application/json' }})
}

// 我司用户最新一条记录查询
export const apiGetLastTolls = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/etctollsapi/cq/tolls/getLastTolls`, data, {
      headers: { 'X-BIND-SN': bindSn  }
    })
}

// 通行记录列表
export const apiGetAllTolls = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/etctollsapi/cq/tolls/orderlist`, data, {
    headers: { 'X-BIND-SN': bindSn  }
  })
}

// 获取预留手机号
export const apiGetReservedPhone = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/user/reservedPhone/getReservedPhoneByApplyOrderSn`, data, {
    headers: { 'X-BIND-SN': bindSn  }
  })
}

// 更新手机号发送短信
export const apiReservedPhoneSendCode = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
  `${APP.HTTP_GW_URL}${urlPrefix}/user/reservedPhone/sendCode`, data, {
    isJson: true,
    headers: { 'X-BIND-SN': bindSn, 'content-type': 'application/json' }
  })
}

// 更新手机号
export const apiUpdateReservedPhone = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/user/reservedPhone/updateByOrderSn`, data, {
    isJson: true,
    headers: { 'X-BIND-SN': bindSn, 'content-type': 'application/json' }
  })
}

// 月月领进度
export const apiGetCouponProcessData = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/activity/marketing/pay/coupon/processData`, data, {
    headers: { 'X-BIND-SN': bindSn  }
  })
}

// 选中月份的优惠券信息
export const apiGetCouponListByMonth = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/activity/marketing/pay/coupon/listCoupon`, data, {
    headers: { 'X-BIND-SN': bindSn  }
  })
}

// 领取优惠券
export const apiReceiveCoupon = (data = {}) => {
  const urlPrefix = store.state.curBindPlate?.urlPrefix
  const bindSn = store.state.curBindPlate?.bindSn
  return ETC_AXIOS.post(
    `${APP.HTTP_GW_URL}${urlPrefix}/activity/marketing/pay/coupon/receive`, data, {
    headers: { 'X-BIND-SN': bindSn  }
  })
}